export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-white/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-bold font-heading text-white">大师兄影视</span>
            </div>
            <p className="text-sm leading-relaxed text-white/50">
              大师兄影视提供海量免费电影、电视剧在线观看，高清画质不卡顿，全集播放，最新影视热播推荐，秒开播放极速加载，畅享流畅观影体验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-white mb-4">快速导航</h3>
            <div className="space-y-2.5">
              {[
                { label: '精选推荐', href: '#carousel' },
                { label: '热门话题', href: '#topics' },
                { label: '热度榜单', href: '#ranking' },
                { label: '主题索引', href: '#index' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.href);
                  }}
                  className="block text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-white mb-4">关于我们</h3>
            <div className="space-y-2.5">
              {[
                { label: '平台介绍', href: '#about' },
                { label: '用户评价', href: '#comments' },
                { label: '常见问题', href: '#faq' },
                { label: '联系与投稿', href: '#contact' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(item.href);
                  }}
                  className="block text-sm text-white/50 hover:text-primary-400 transition-colors cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-white mb-4">合作伙伴</h3>
            <p className="text-sm text-white/50 leading-relaxed">
              感谢所有合作伙伴对大师兄影视的支持与信任。我们期待与更多优质内容方携手合作，共同为观众带来更好的观影体验。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <div className="w-9 h-9 rounded-lg bg-white/5 flex items-center justify-center cursor-pointer hover:bg-white/10 transition-colors">
                <i className="ri-wechat-line text-sm text-white/60"></i>
              </div>
              <div className="w-9 h-9 rounded-lg bg-white/5 flex items-center justify-center cursor-pointer hover:bg-white/10 transition-colors">
                <i className="ri-weibo-line text-sm text-white/60"></i>
              </div>
              <div className="w-9 h-9 rounded-lg bg-white/5 flex items-center justify-center cursor-pointer hover:bg-white/10 transition-colors">
                <i className="ri-bilibili-line text-sm text-white/60"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; 2020-2026 大师兄影视 · 免费电影在线看剧高清视频不卡顿全集播放
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-white/40 cursor-pointer hover:text-white/60 transition-colors">隐私政策</span>
            <span className="text-xs text-white/40 cursor-pointer hover:text-white/60 transition-colors">服务条款</span>
            <span className="text-xs text-white/40 cursor-pointer hover:text-white/60 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}